<template>
  <div class="page-block">
    <header-bar>登録情報</header-bar>
    <div class="page-block__heading page-block__heading--withbar">
      <h3 class="page-block__title">
        アカウント情報 -
        <span>登録</span>
      </h3>
    </div>
    <div
      class="profile-edit__head-text">
      <span>ご登録ありがとうございます。</span>
      <br>早速、あなたの楽曲を 配信してみましょう。
      <br>
      <a
        :href="redirectUrl"
        class="c-text-link">ダッシュボードに進む</a>
      <br>（5秒後に自動で画面が遷移します）
    </div>
  </div>
</template>

<script>
import HeaderBar from '../HeaderBar'

export default {
  name: 'SignUpSuccess',
  components: {
    HeaderBar,
  },
  props: {
    redirect_url: {
      type: String,
      default: '/client',
    },
  },
  data() {
    return {
      redirectUrl: '/client',
    }
  },
  mounted() {
    this.$store.commit('hideSidebar')
    this.redirectUrl = this.redirect_url
    const type = this.$route.query?.type ?? 'revenue-share'
    if (this.$route.query.invitation_code) {
      if (type === 'copyright') {
        this.redirectUrl = `/client/${type}/invitation-code?invitation_code=${this.$route.query.invitation_code}&rsId=${this.$route.query.rsId}&type=${type}`
      } else {
        this.redirectUrl = `/client/${type}/invitation-code?invitation_code=${this.$route.query.invitation_code}&rsId=${this.$route.query.rsId}&productId=${this.$route.query.productId}&type=${type}`
      }
    }
    setTimeout(() => {
      if (this.$route.query.invitation_code) {
        if (type === 'copyright') {
          window.location.href = `/client/${type}/invitation-code?invitation_code=${this.$route.query.invitation_code}&rsId=${this.$route.query.rsId}&type=${type}`
        } else {
          window.location.href = `/client/${type}/invitation-code?invitation_code=${this.$route.query.invitation_code}&rsId=${this.$route.query.rsId}&productId=${this.$route.query.productId}&type=${type}`
        }
      } else window.location.href = this.redirectUrl
    }, 3000)
  },
  destroyed() {
    this.$store.commit('showSidebar')
  },
}
</script>
